import { render, staticRenderFns } from "./ParcelView.vue?vue&type=template&id=42d16c28&scoped=true"
import script from "./ParcelView.vue?vue&type=script&lang=js"
export * from "./ParcelView.vue?vue&type=script&lang=js"
import style0 from "./ParcelView.vue?vue&type=style&index=0&id=42d16c28&prod&lang=css"
import style1 from "./ParcelView.vue?vue&type=style&index=1&id=42d16c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d16c28",
  null
  
)

export default component.exports